export const DoughnutLabel = {
    id: "doughnut-label",
    beforeDatasetsDraw(chart) {
        const { ctx, options } = chart;
        if (!options.plugins.centerLabel) {
            return;
        }
        ctx.save();
        const xCoor = chart.getDatasetMeta(0).data[0].x;
        const yCoor = chart.getDatasetMeta(0).data[0].y;
        ctx.font = "Bold 45px/20px Pagabo Sans Display";
        ctx.fillStyle = "#001932";
        ctx.textAlign = "center";
        ctx.textBaseline = "middle";
        ctx.fillText(`${options.plugins.centerLabel}`, xCoor, yCoor);
    },
};

export const DoughnutHoverShadow = {
    id: "doughnut-hover-shadow",
    beforeDraw: function (chart) {
        const ctx = chart.ctx;
        const activeElements = chart.getActiveElements();

        if (activeElements.length) {
            // Get the dataset index and data index of the hovered element
            const { datasetIndex, index } = activeElements[0];
            const meta = chart.getDatasetMeta(datasetIndex);
            const arc = meta.data[index];

            ctx.save();

            // Apply shadow styles
            ctx.shadowColor = "rgba(0, 0, 0, 0.5)";
            ctx.shadowBlur = 6;
            ctx.shadowOffsetX = 0;
            ctx.shadowOffsetY = 3;

            // Redraw the specific arc with shadow
            arc.draw(ctx);

            ctx.restore();
        }
    },
};

function getOrCreateLegendList(chart, containerId) {
    const legendContainer = document.getElementById(containerId);

    let listContainer = legendContainer.querySelector("ul");
    if (!listContainer) {
        listContainer = document.createElement("ul");
        listContainer.classList.add("flex", "flex-row", "space-x-5");

        legendContainer.appendChild(listContainer);
    }

    return listContainer;
}

export const HtmlLegendPlugin = {
    id: "htmlLegend",
    afterUpdate(chart, args, options) {
        if (!options.containerId) {
            return;
        }

        const ul = getOrCreateLegendList(chart, options.containerId);

        while (ul.firstChild) {
            ul.firstChild.remove();
        }

        const items = chart.options.plugins.legend.labels.generateLabels(chart);
        const hasDisabledItem = items.some((item) => {
            return !chart.isDatasetVisible(item.datasetIndex);
        });

        items.forEach((item) => {
            const li = document.createElement("li");
            li.classList.add(
                "cursor-pointer",
                "flex",
                "flex-row",
                "items-center",
            );

            li.onclick = () => {
                const { type } = chart.config;
                if (
                    hasDisabledItem &&
                    chart.isDatasetVisible(item.datasetIndex)
                ) {
                    return;
                }

                if (type === "pie" || type === "doughnut") {
                    // Pie and doughnut charts only have a single dataset and visibility is per item
                    chart.toggleDataVisibility(item.index);
                } else {
                    chart.setDatasetVisibility(
                        item.datasetIndex,
                        !chart.isDatasetVisible(item.datasetIndex),
                    );
                }
                chart.update();
            };

            // Color box
            const boxSpan = document.createElement("span");
            boxSpan.classList.add("rounded-lg");
            boxSpan.style.background = item.strokeStyle;
            boxSpan.style.flexShrink = 0;
            boxSpan.style.height = "12px";
            boxSpan.style.marginRight = "10px";
            boxSpan.style.width = "44px";

            // Text
            const textContainer = document.createElement("p");
            textContainer.classList.add(
                "m-0",
                "p-0",
                "text-xs",
                "text-primary",
                "font-bold",
            );
            textContainer.style.textDecoration = item.hidden
                ? "line-through"
                : "";

            const text = document.createTextNode(item.text);
            textContainer.appendChild(text);

            li.appendChild(boxSpan);
            li.appendChild(textContainer);
            ul.appendChild(li);
        });
    },
};
